// ASAP Capital - Value Add Real Estate Private Equity Fund

export const companyInfo = {
  name: "ASAP Capital",
  tagline: "Value-Add Real Estate Investments",
  description: "A Reg D 506(c) private equity fund exclusively for accredited investors and institutions. With 18+ years of Houston market expertise since 2005, we are a data-driven, vertically integrated operator specializing in distressed real estate acquisitions across Greater Houston.",
  founded: "2005",
  headquarters: "Houston, TX",
  fundType: "506(c)",
  targetRaise: "$25M",
  minInvestment: "$100,000",
  logo: "https://customer-assets.emergentagent.com/job_realestate-fund-7/artifacts/hywwykpi_eb79b399-a596-460e-85f0-525cccff1722.png"
};

export const stats = [
  { value: "$25M", label: "Current Raise" },
  { value: "12+", label: "Years Multifamily" },
  { value: "2.4x", label: "Target Multiple" },
  { value: "28%", label: "Proven IRR" }
];

export const fundDetails = {
  structure: "Delaware Limited Partnership",
  fundType: "Reg D 506(c)",
  targetRaise: "$25,000,000",
  minInvestment: "$100,000",
  targetIRR: "20-28%",
  targetMultiple: "1.8x - 2.5x",
  holdPeriod: "5-7 Years",
  managementFee: "1.5%",
  carriedInterest: "20%",
  preferredReturn: "8%"
};

export const investorTypes = [
  {
    id: 1,
    title: "High Net Worth Individuals",
    description: "Accredited investors seeking diversified real estate exposure with tax-advantaged returns and quarterly distributions.",
    minInvestment: "$100,000",
    icon: "User"
  },
  {
    id: 2,
    title: "Family Offices",
    description: "Multi-generational wealth preservation through institutional-quality real estate with aligned GP/LP interests.",
    minInvestment: "$250,000",
    icon: "Users"
  },
  {
    id: 3,
    title: "Institutional Investors",
    description: "Pension funds, endowments, and fund-of-funds seeking Houston market exposure with disciplined risk management.",
    minInvestment: "$500,000",
    icon: "Building"
  }
];

export const leadershipTeam = {
  name: "Leadership",
  credentials: [
    "Master of Science in Industrial Engineering & Management",
    "Licensed Real Estate Agent since 2005",
    "18+ Years Houston Market Experience"
  ],
  verticalIntegration: [
    {
      title: "Property Management",
      description: "In-house property management team for operational control and cost efficiency"
    },
    {
      title: "Insurance Services", 
      description: "Dedicated insurance agents ensuring optimal coverage and risk management"
    },
    {
      title: "Data-Driven Operations",
      description: "Engineering-minded approach to asset analysis and portfolio optimization"
    }
  ]
};

export const team = [
  {
    id: 1,
    name: "Yogesh Patil",
    role: "Leadership",
    title: "Managing Partner",
    description: "18 years of CRE Acquisition & Development across Texas Market",
    bio: "Yogesh Patil brings over 18 years of experience in commercial real estate acquisition and development across the Texas market, with a focus on value-add multifamily and distressed property investments in Greater Houston.",
    expertise: ["CRE Acquisitions", "Value-Add Strategy", "Texas Markets", "Portfolio Management"],
    image: "https://customer-assets.emergentagent.com/job_realestate-fund-7/artifacts/vk9xla3e_WhatsApp%20Image%202026-01-17%20at%2012.50.46%20AM%20%281%29.jpeg",
    isFromGroupImage: false,
    position: 0
  },
  {
    id: 2,
    name: "Samara Shaw",
    role: "Leadership",
    title: "Chief Investment Officer",
    description: "12 years of Commercial RE Value add experience",
    bio: "Samara Shaw has over 12 years of experience executing value-add strategies across commercial real estate assets, overseeing underwriting, capital deployment, and operational performance.",
    expertise: ["Value-Add Execution", "Underwriting", "Capital Deployment", "Asset Operations"],
    image: "https://customer-assets.emergentagent.com/job_realestate-fund-7/artifacts/lki8hxrk_d162efa6-4185-45d6-ae10-ab704214fa3e.png",
    isFromGroupImage: false,
    position: 1
  },
  {
    id: 3,
    name: "Deelip Mhaske",
    role: "Advisor",
    title: "Strategic Advisor",
    description: "Commissioner, New Jersey India Commission. President, Foundation for Human Horizon.",
    bio: "Deelip Mhaske brings governance expertise and public policy insight to ASAP Capital's strategic direction, with deep experience in institutional frameworks and foundation management.",
    education: "Harvard Business School | MPhil IIT Bombay | MBA Rutgers Business School",
    expertise: ["Governance", "Public Policy", "Institutional Strategy", "Foundation Leadership"],
    image: "https://customer-assets.emergentagent.com/job_asapequity/artifacts/zgtaj1y3_1763095137035.jpg",
    isFromGroupImage: false,
    position: 3
  },
  {
    id: 4,
    name: "Pravin Patil",
    role: "Advisor",
    title: "Technology Advisor",
    description: "VC | Deep Tech & AI",
    bio: "Pravin Patil provides technology and data strategy guidance, bringing venture capital experience and deep expertise in AI and emerging technologies to drive data-driven investment decisions.",
    expertise: ["Venture Capital", "Deep Tech", "AI & Analytics", "Technology Strategy"],
    image: "https://customer-assets.emergentagent.com/job_asapequity/artifacts/jscajex0_1664893226150.jpg",
    isFromGroupImage: false,
    position: 2
  },
  {
    id: 5,
    name: "Dr. Bhupesh Patil",
    role: "Advisor",
    title: "Medical Advisor",
    description: "Doctor, Diabetic Specialist, and Cardiologist",
    bio: "Dr. Bhupesh Patil serves as an independent advisor focused on long-term impact and stewardship, bringing a conservative, family-office style approach to capital preservation and responsible investing.",
    expertise: ["Investor Stewardship", "Long-term Planning", "Risk Oversight", "Ethics & Sustainability"],
    image: "https://customer-assets.emergentagent.com/job_tx-property-experts/artifacts/0nki0e9w_Dr%20Bhupesh%20Patil.jpg",
    isFromGroupImage: false,
    position: 4
  }
];

// Team group photo for hero section
export const teamGroupPhoto = "https://customer-assets.emergentagent.com/job_asapequity/artifacts/z2olbqcb_a0314f15-2c40-4b9b-a183-91fe1a118164.png";

export const contactInfo = {
  email: "info@asapcapital.net",
  phone: "+1 (346) 310-0995",
  address: {
    street: "15915 Katy Freeway",
    city: "Houston",
    state: "TX",
    zip: "77094"
  }
};

export const investmentFocus = [
  {
    id: 1,
    title: "Multifamily Properties",
    description: "Class B and C apartment communities with value-add potential through renovations, operational improvements, and market repositioning.",
    icon: "Building2",
    image: "https://customer-assets.emergentagent.com/job_tx-property-experts/artifacts/pgbhebdp_666f25fc-b975-432d-a6cd-45b38c09faa0.png"
  },
  {
    id: 2,
    title: "Retail Centers",
    description: "Neighborhood and community retail centers requiring lease-up, tenant mix optimization, and capital improvements.",
    icon: "Store",
    image: "https://customer-assets.emergentagent.com/job_tx-property-experts/artifacts/n5uhqmr2_69fdc939-5875-4eba-9889-e6fa379f0577.png"
  },
  {
    id: 3,
    title: "Distressed Assets",
    description: "Opportunistic acquisitions of distressed properties and situations requiring turnaround expertise.",
    icon: "TrendingUp",
    image: "https://customer-assets.emergentagent.com/job_tx-property-experts/artifacts/l2cpduz0_1a31294a-313a-4573-ab32-15dd18f31129.png"
  },
  {
    id: 4,
    title: "Private Lending Solutions",
    description: "Access to private lenders with attractive rates when conventional financing isn't available. Creative capital solutions for real estate investors.",
    icon: "Landmark",
    image: "https://customer-assets.emergentagent.com/job_tx-property-experts/artifacts/fr3osnak_05abadb8-1274-4721-84ed-40bab5cf039e.png"
  }
];

export const calendlyLink = "https://calendly.com/aiasap-info/asap-fund-discussion";

export const valueCreation = [
  {
    id: 1,
    title: "Operational Excellence",
    description: "Implementing institutional-grade property management and cost optimization strategies."
  },
  {
    id: 2,
    title: "Lease Modifications",
    description: "Strategic lease restructuring to maximize NOI and property value."
  },
  {
    id: 3,
    title: "Asset Repositioning",
    description: "Physical improvements and rebranding to capture higher market rents."
  },
  {
    id: 4,
    title: "Market Timing",
    description: "Disciplined acquisition during market dislocations and strategic exits at peak values."
  }
];

export const geographicFocus = [
  { name: "Houston", properties: 18, description: "Core metro focus with diverse asset types" },
  { name: "Katy", properties: 8, description: "High-growth suburban corridor" },
  { name: "Sugar Land", properties: 6, description: "Affluent suburban market" },
  { name: "The Woodlands", properties: 5, description: "Premium master-planned community" },
  { name: "Pearland", properties: 4, description: "Emerging suburban opportunity" }
];

export const trackRecord = [
  {
    id: 1,
    name: "Jarmese Apartments (Anais Place)",
    type: "Multifamily",
    location: "4835-4840 Jarmese St, Houston, TX 77033",
    units: "72 Units",
    acquired: "2014",
    exited: "-",
    irr: "-",
    multiple: "-",
    status: "Active",
    image: "https://customer-assets.emergentagent.com/job_asapequity/artifacts/08whp4id_fa144646-1695-402a-989f-059766089009.png"
  },
  {
    id: 2,
    name: "Hollyvale Apartments",
    type: "Multifamily + Storage",
    location: "Houston, TX",
    units: "40 Units + 40 Storage",
    acquired: "2013",
    exited: "Realized",
    irr: "28%",
    multiple: "2.4x",
    status: "Realized",
    image: "https://customer-assets.emergentagent.com/job_tx-property-experts/artifacts/kexllnmx_490aeb1c-f827-4484-9025-f487279765b7.png"
  },
  {
    id: 3,
    name: "Northgreen Atrium Building",
    type: "Office",
    location: "1300 N Sam Houston Pkwy E, Houston, TX",
    units: "75,000 SF",
    acquired: "-",
    exited: "-",
    irr: "-",
    multiple: "-",
    status: "Active",
    image: "https://customer-assets.emergentagent.com/job_asapequity/artifacts/cv95j4qz_f009021d-4a44-4152-8f21-08346032a255.png"
  },
  {
    id: 4,
    name: "Griggs Shopping Center",
    type: "Retail",
    location: "4546-4564 Griggs Rd, Houston, TX",
    units: "Retail Center",
    acquired: "-",
    exited: "-",
    irr: "-",
    multiple: "-",
    status: "Active",
    image: "https://customer-assets.emergentagent.com/job_asapequity/artifacts/fgrcxat0_e566c84b-016a-486b-87c5-d8862f36af0d.png"
  }
];

export const navLinks = [
  { name: "About", href: "#about" },
  { name: "Strategy", href: "#strategy" },
  { name: "Fund Terms", href: "#fund-terms" },
  { name: "Track Record", href: "#portfolio" },
  { name: "Lending", href: "#lending" },
  { name: "Team", href: "#team" },
  { name: "Contact", href: "#contact" }
];

// Insights / Articles data
export const insights = [
  {
    id: 1,
    title: "Why Houston Multifamily Outperforms: A 2025 Market Analysis",
    slug: "houston-multifamily-market-analysis-2025",
    excerpt: "Houston's multifamily sector continues to deliver exceptional returns driven by population growth, job creation, and favorable regulatory environment. Our analysis reveals key submarkets positioned for outsized gains.",
    category: "Market Research",
    author: "Yogesh Patil",
    authorRole: "Managing Partner",
    publishDate: "2025-01-15",
    readTime: "8 min read",
    featured: true,
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80",
    tags: ["Houston", "Multifamily", "Market Analysis"]
  },
  {
    id: 2,
    title: "Value-Add Strategy: Maximizing Returns in Today's Market",
    slug: "value-add-strategy-maximizing-returns",
    excerpt: "How disciplined value-add execution and operational improvements can generate 20%+ IRR even in competitive markets. A deep dive into our proven methodology.",
    category: "Investment Strategy",
    author: "Samara Shaw",
    authorRole: "Chief Investment Officer",
    publishDate: "2025-01-08",
    readTime: "6 min read",
    featured: false,
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80",
    tags: ["Value-Add", "Strategy", "Returns"]
  },
  {
    id: 3,
    title: "Texas Property Tax Outlook: What Investors Need to Know",
    slug: "texas-property-tax-outlook-investors",
    excerpt: "Understanding the evolving Texas property tax landscape and strategies to optimize your real estate portfolio's tax efficiency in 2025 and beyond.",
    category: "Tax & Regulatory",
    author: "Deelip Mhaske",
    authorRole: "Strategic Advisor",
    publishDate: "2024-12-20",
    readTime: "5 min read",
    featured: false,
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&q=80",
    tags: ["Tax Strategy", "Texas", "Regulations"]
  },
  {
    id: 4,
    title: "The Rise of Houston's Energy Corridor Submarkets",
    slug: "houston-energy-corridor-submarkets",
    excerpt: "Exploring investment opportunities in Houston's western energy corridor, where corporate relocations and infrastructure development are driving exceptional rental growth.",
    category: "Market Research",
    author: "Yogesh Patil",
    authorRole: "Managing Partner",
    publishDate: "2024-12-12",
    readTime: "7 min read",
    featured: false,
    image: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800&q=80",
    tags: ["Energy Corridor", "Houston", "Submarkets"]
  }
];
